/**
 * 模块名称: 审批流模版
 * @author xuzhongyuan@372163.com
 */

import React from 'react'
import { Icon } from 'antd'
import Node from '../Node'

const Temp = ({ nodes, onClick, currentId }) => {
  const onClickItem = item => {
    if (item.type > 2 || item.id === currentId) {
      return
    }
    onClick(item)
  }

  const BranchLine = ({ branches }) => {
    const list = []
    for(let i = 0; i < branches.length; i++){
      list.push((<Icon key={i} type="arrow-down" />))
      list.push((<span key={"k"+i} className="node-line"></span>))
    }
    list.pop()
    return (
        <div className="row-line">
          {list}
        </div>
    )
  }

  const Branch = ({ nodeArray }) => { 
    return (
      <>
        {nodeArray.map((item, index) => {
          if (item.type === 2) {
            const { branchesNodesTree } = item
            let maxLen = 0
            branchesNodesTree.forEach(d => {
              if (d.length > maxLen) {
                maxLen = d.length
              }
            })
            return (
              <div className="branch-wrap" key={item.id}>
                <BranchLine branches={branchesNodesTree}/>
                <div className="branch">
                  {branchesNodesTree.map((d, n) => {
                    return (
                      <div key={n} className="branch-node">
                        <Branch nodeArray={d} />
                        {d.length < maxLen && <span className="line-more"></span>}
                      </div>
                    )
                  })}
                </div>
                <div className="row-line-one">
                  <span className="line-border"></span>
                  <Icon type="arrow-down" />
                </div>
              </div>
            )
          } else if (item.type === 5) {
            return null
          } else {
            return (
              <Node key={item.id} data={item} index={index} onClickItem={onClickItem} currentId={currentId} length={nodeArray.length} />
            )
          }
        })}
      </>
    )
  }

  return (
    <div className="temp temp-2">
      <Branch nodeArray={nodes} />
    </div>
  )
}

export default Temp